import React from "react";

const Card = ({
  title,
  icon,
  long,
  short,
  longLabel = "Long",
  shortLabel = "Short",
  active,
}) => {
  return (
    <div className={`card ${active ? "card_active" : ""}`}>
      <div className="card-header">
        <span className="card-title">{title}</span>
      </div>
      <div className="card-content">
        <span className="card-label card-long-label">{long}</span>
      </div>
    </div>
  );
};

const LongShortCards = ({ data }) => {
  const cardData = [
    {
      title: "No. of days",
      long: (data && data?.number_of_days) || "--",
      active: true,
    },
    {
      title: "Avg no. of trades",
      long: (data && data?.number_of_trade) || "--",
    },
    {
      title: "Positive Days",
      long: (data && data?.positive_days) || "--",
    },
    {
      title: "Avg Positive Days",
      long:
        data &&
        data?.avg_positive_days &&
        `${Number(data?.avg_positive_days) || "--"}`,
    },
    {
      title: "Negative days",
      long: (data && data?.negative_days),
    },
    {
      title: "Avg Negative days",
      long: data && (data?.avg_negative_days ),
    },
  ];

  return (
    <div className="trading_days_analysis_main">
      {cardData.map((item, index) => (
        <Card
          key={index}
          title={item.title}
          long={item.long}
          active={item.active}
        />
      ))}
    </div>
  );
};

// Example Icons (replace these with your actual SVG icons)
// const Icon1 = () => <div>📊</div>;
// const Icon2 = () => <div>💲</div>;
// const Icon3 = () => <div>🏆</div>;
// const Icon4 = () => <div>📈</div>;
// const Icon5 = () => <div>⚖️</div>;

export default LongShortCards;
